class CrProductDialog extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('dialog');
    this.opener = this.querySelector('[data-cr-dialog-open]');
    if (!this.dialog || !this.opener) return;
    this.opener.addEventListener('click', () => {
      this.dialog.showModal();
      this.querySelector('[data-cr-dialog-close]')?.focus();
    }, options);
    this.querySelector('[data-cr-dialog-close]')?.addEventListener('click', () => this.dialog.close(), options);
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    }, options);
    this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
  }
  disconnectedCallback() { this.controller?.abort(); }
}
class CrProductStatus extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.scope = this.closest('dialog, .shopify-section');
    this.scope?.addEventListener('variant:updated', (event) => {
      const source = event.detail?.data?.html?.querySelector('cr-product-status [data-cr-status-content]');
      if (source) this.querySelector('[data-cr-status-content]')?.replaceWith(source.cloneNode(true));
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
function bindLoupe(gallery) {
  if (gallery.dataset.crLoupeBound || !gallery.hasAttribute('data-cr-loupe')) return;
  gallery.dataset.crLoupeBound = 'true';
  let loupe;
  let active;
  const clear = () => { loupe?.remove(); loupe = null; active = null; };
  gallery.addEventListener('pointermove', (event) => {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches || event.pointerType === 'touch') return;
    const slide = event.target.closest('[data-zoom-src]');
    if (!slide || slide.closest('dialog') || event.target.closest('button')) { clear(); return; }
    const img = slide.querySelector('img');
    if (!img) return;
    const rect = img.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    if (active !== slide) {
      clear(); active = slide;
      loupe = document.createElement('span');
      loupe.className = 'cr-product-loupe';
      loupe.setAttribute('aria-hidden', 'true');
      loupe.style.backgroundImage = `url("${slide.dataset.zoomSrc}")`;
      slide.append(loupe);
    }
    const slideRect = slide.getBoundingClientRect();
    const factor = 2.5;
    loupe.style.left = `${event.clientX - slideRect.left - 90}px`;
    loupe.style.top = `${event.clientY - slideRect.top - 90}px`;
    loupe.style.backgroundSize = `${rect.width * factor}px ${rect.height * factor}px`;
    loupe.style.backgroundPosition = `${90 - x * factor}px ${90 - y * factor}px`;
  });
  gallery.addEventListener('pointerleave', clear);
  gallery.addEventListener('click', clear);
}
if (!customElements.get('cr-product-dialog')) customElements.define('cr-product-dialog', CrProductDialog);
if (!customElements.get('cr-product-status')) customElements.define('cr-product-status', CrProductStatus);
document.querySelectorAll('product-media-gallery').forEach(bindLoupe);
new MutationObserver((records) => {
  for (const record of records) for (const node of record.addedNodes) {
    if (!(node instanceof Element)) continue;
    if (node.matches('product-media-gallery')) bindLoupe(node);
    node.querySelectorAll('product-media-gallery').forEach(bindLoupe);
  }
}).observe(document.documentElement, { childList: true, subtree: true });
